'use client';
const YM_SOURCE = 'https://mc.yandex.ru/metrika/tag.js';

export { YM_SOURCE };
//# sourceMappingURL=domain.js.map
